import { Colors } from '../consts/Colors';
import RoundedButton2 from './RoundedButton2';
import Card from './Card';
import { CartesInfos } from '../consts/CartesInfos';

// Création du deck de jeu pour la partie 1

export default class Deck extends Phaser.GameObjects.Container {
    constructor(scene, x, y) {
        super(scene, x, y, []);
        scene.add.existing(this);

        this.scene = scene;
        this.num = this.scene.game.data.cardNumber + 1
        this.cardNumber = this.scene.game.data.cardNumber
        this.isFirstDrop = true


        this.rect = this.scene.add.rexRoundRectangle(0, 0, 560, 308, 26, Colors.Elmt.Blue).setOrigin(0.5);
        this.rect.setStrokeStyle(2, Colors.Elmt.White, 1);
        this.add(this.rect);

        this.repLogo = this.scene.add.image(-230, -105, 'goodAnswer').setOrigin(0.5);
        this.add(this.repLogo);
        this.repLogo.setAlpha(0)

        this.repText = this.scene.add.text(-200, -105, "BRAVO", {
            font: "40px MassiliaBold",
            color: Colors.Text.Red
        }).setOrigin(0, 0.5)
        this.add(this.repText)
        this.repText.setAlpha(0)

        this.cardFeedBack = this.scene.add.text(0, this.repText.y + 25, "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.", {
            font: "22px MassiliaRegular",
            color: Colors.Text.Blue,
            align: "left",
            lineSpacing: 5,
            wordWrap: { width: 500, useAdvancedWrap: true }
        }).setOrigin(0.5, 0)
        this.add(this.cardFeedBack)
        this.cardFeedBack.setAlpha(0)

        this.nextBtn = new RoundedButton2(this.scene, 0, 60, 160, "Suivant");
        this.add(this.nextBtn);
        this.nextBtn.setAlpha(0)
        this.nextBtn.setClickFunction(() => {
            this.card.destroy()
            this.nextBtn.setAlpha(0)
            if (this.isFirstDrop === true) {
                this.scene.score.bravo++
            } else {
                this.isFirstDrop = true

            }
            if (this.num === 11) {
                this.card.destroy()
                this.scene.launchStep2()
            } else {
                this.setDeckAction(CartesInfos[this.scene.game.data.cardNumber])
                this.scene.itemsAll.forEach(x => {
                    if (x.isError) {
                        x.setActive()
                    }
                });
            }
        })

        this.restartBtn = new RoundedButton2(this.scene, 0, 60, 160, "Réessayer");
        this.add(this.restartBtn);
        this.restartBtn.setAlpha(0)
        this.restartBtn.setClickFunction(() => {
            if (this.isFirstDrop === true) {
                this.scene.score.mauvais++
                this.isFirstDrop = false
            }
            this.card.destroy()

            this.restartBtn.setAlpha(0)
            this.setDeckAction(CartesInfos[this.scene.game.data.cardNumber])
            this.scene.itemsAll.forEach(x => {
                if (x.isError) {
                    x.item.setTexture('imgPlaceholder');
                    x.item.setTint(Colors.Elmt.Red);
                    x.item.setScale(1);
                    x.item.x = 0;
                    this.scene.itemsAll.forEach(x => {
                        x.setDepth(0)

                    })
                }
            });
        })


        this.rectLabel = this.scene.add.rexRoundRectangle(0, this.rect.height / 2, 560, 48, {
            tl: 0,
            tr: 0,
            bl: 26,
            br: 26
        }, Colors.Elmt.White).setOrigin(0.5, 1);
        this.add(this.rectLabel);
        this.rectLabel.setAlpha(0)

        this.numText = this.scene.add.text(250, this.rectLabel.y - 24, this.num + "/11", {
            font: "20px MassiliaExtraLight",
            color: Colors.Text.Blue
        }).setOrigin(1, 0.5)
        this.add(this.numText)
        this.numText.setAlpha(0)

        this.labelName = this.scene.add.text(-256, this.rectLabel.y - 24, 'Prestations de dépannage / Vente', {
            font: "24px MassiliaExtraBold",
            color: Colors.Text.Blue
        }).setOrigin(0, 0.5)
        this.add(this.labelName)
        this.labelName.setAlpha(0)

    }

    setDeckAction(cardData) {
        // this.isFirstDrop = true
        this.cardData = cardData
        this.card = new Card(this.scene, 0, 0, this.cardData, this);
        this.add(this.card);
        this.repLogo.setAlpha(0)
        this.repText.setAlpha(0)
        this.cardFeedBack.setAlpha(0)

        this.labelName.setText(this.cardData.titre)
        this.rect.fillColor = Colors.Elmt.Blue
        this.rect.setStrokeStyle(2, Colors.Elmt.White, 1);
        this.rectLabel.fillColor = Colors.Elmt.White
        this.numText.setColor(Colors.Text.Blue)
        this.labelName.setColor(Colors.Text.Blue)
        this.num = this.scene.game.data.cardNumber + 1
        this.numText.setText(this.num + "/11")
        this.rectLabel.setAlpha(1)
        this.numText.setAlpha(1)
        this.labelName.setAlpha(1)
    }
    setDeckTrue(content) {
        if (content.length > 210 && content.length <= 250) {
            console.log("content 210", content.length)
            this.cardFeedBack.setFontSize(20)
            this.nextBtn.y = 75
        } else if (content.length > 250) {
            console.log("content 250", content.length)
            this.cardFeedBack.setFontSize(19)
            this.nextBtn.y = 75
        } else {
            console.log("content Small", content.length)
            this.cardFeedBack.setFontSize(22)
            this.nextBtn.y = 60
        }
        this.repLogo.setAlpha(1)
        this.repText.setAlpha(1)
        this.cardFeedBack.setAlpha(1)
        this.nextBtn.setAlpha(1)
        if (this.num == 11) {
            this.nextBtn.setLocked()
        }

        this.repLogo.setTexture('goodAnswer')
        this.repText.setText("BRAVO")
        this.repText.setFill(Colors.Text.Green)
        this.cardFeedBack.setText(content)
        this.rect.fillColor = Colors.Elmt.White
        this.rect.setStrokeStyle(2, Colors.Elmt.Green, 1);
        this.rectLabel.fillColor = Colors.Elmt.Green
        this.numText.setColor(Colors.Text.White)
        this.labelName.setColor(Colors.Text.White)
    }
    setDeckFalse(content) {
       if (content.length > 210 && content.length <= 250) {
            console.log("content 210", content.length)
            this.cardFeedBack.setFontSize(20)
            this.restartBtn.y = 75
        } else if (content.length > 250) {
            console.log("content 250", content.length)
            this.cardFeedBack.setFontSize(19)
            this.restartBtn.y = 75
        } else {
            console.log("content Small", content.length)
            this.cardFeedBack.setFontSize(22)
            this.restartBtn.y = 60
        }
        this.repLogo.setAlpha(1)
        this.repText.setAlpha(1)
        this.cardFeedBack.setAlpha(1)
        this.restartBtn.setAlpha(1)
        this.repLogo.setTexture('badAnswer')
        this.repText.setText("ATTENTION")
        this.repText.setFill(Colors.Text.Red)
        this.cardFeedBack.setText(content)
        this.rect.fillColor = Colors.Elmt.White
        this.rect.setStrokeStyle(2, Colors.Elmt.Red, 1);
        this.rectLabel.fillColor = Colors.Elmt.Red
        this.numText.setColor(Colors.Text.White)
        this.labelName.setColor(Colors.Text.White)

    }




}